import { cn } from "../utils/cn.js";

type Props = {
  className?: string;
  lines?: number;
};

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "animate-skeleton rounded-md bg-gray-200",
        className
      )}
    />
  );
}

export function SkeletonLines({ lines = 3, className }: Props) {
  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn("h-4", i === lines - 1 ? "w-2/3" : "w-full")}
        />
      ))}
    </div>
  );
}
